import { render, staticRenderFns } from "./ProjectLogo.vue?vue&type=template&id=7aed79d6&scoped=true"
import script from "./ProjectLogo.vue?vue&type=script&lang=js"
export * from "./ProjectLogo.vue?vue&type=script&lang=js"
import style0 from "./ProjectLogo.vue?vue&type=style&index=0&id=7aed79d6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aed79d6",
  null
  
)

export default component.exports